/**
 * Tema de colores. Usa variables CSS que BrandingContext sobrescribe desde config.json.
 * Los componentes pueden usar theme.primaryColor etc. en estilos inline.
 */
const theme = {
  background: 'var(--tenant-primary, #ffde59)',
  primaryColor: 'var(--tenant-primary, #ffde59)',
  secundaryColor: 'var(--tenant-accent, #332E5A)',
  black: '#000000',
  white: '#ffffff',
  green: 'var(--tenant-success, #31a184)',
  red: 'var(--tenant-danger, #ff3131)',
  textColor: '#ffffff',
  blue: 'var(--tenant-accent, #332E5A)'
};

export default theme;